import PropTypes from 'prop-types';
import moment from 'moment';
// material
import { TableRow, TableCell, Switch, FormControlLabel } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
// component
import Controls from '../../controls/Controls';

export default function DataSourceRow({ dataSource, openInPopup, deleteDataSource, index,handleDataSourceActivation }) {

    const displayUserType = (obj) => {
        let displayList = obj?.map((item) => item['userTypeName'])
        return displayList?.length ? displayList.join(', ')  : ""
    }

    return (
        <TableRow key={dataSource?._id}>
            <TableCell>{index}</TableCell>
            <TableCell>{dataSource?.dbType}</TableCell>
            <TableCell>{dataSource?.dbName}</TableCell>
            <TableCell>{dataSource?.projectId}</TableCell>
            <TableCell> {moment(dataSource?.updatedAt).fromNow()} </TableCell>
            <TableCell>
                <Controls.ActionButton
                    color="root"
                    onClick={() => { openInPopup(dataSource) }}
                >
                    <EditOutlinedIcon fontSize="small" />
                </Controls.ActionButton>
                <Controls.ActionButton
                    color="root"
                    onClick={() => {
                        deleteDataSource(dataSource)
                    }}
                >
                    <DeleteIcon />
                </Controls.ActionButton>
            </TableCell>
            <TableCell>
                  <FormControlLabel
                    className="text-plain"
                    control={<Switch checked={dataSource?.isActive}
                    onChange={() => handleDataSourceActivation(dataSource,index)}/>}
                    label="" />
            </TableCell>
        </TableRow>
    )
}
DataSourceRow.propTypes = {
    usertype: PropTypes.object
}